import React from 'react';
import { Link } from 'react-router-dom';

import BookList from 'rebook/apps/books/components/BookList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchAudioBookList = ({ audioBookList, audioBooksCount, query }) => (
  <div className={styles.section}>
    <div className="title-1 jest-search-audiobooks-block">Аудиокниги</div>
    {audioBooksCount > 6 && (
      <Link className="cy-search-all-audiobooks"
        to={{
          pathname: `/search/audiobooks/`,
          state: { audioBookList, audioBooksCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {audioBooksCount} {pluralize(audioBooksCount, 'аудиокнига', 'аудиокниги', 'аудиокниг')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      <BookList isAudio books={audioBookList.length > 8 ? audioBookList.slice(0, 8) : audioBookList} />
    </div>
  </div>
);

export default SearchAudioBookList;
